const customerInfoKeys = ['firstname', 'lastname', 'telephone', 'email', 'user_comment', 'paymentMethod',
  'bookingUrl', 'coach_firstname', 'coach_lastname', 'coach_street', 'coach_postcode', 'coach_city', 'slug'];

export default customerInfoKeys;

export const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phoneRegexp = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
export const nameRegexp = /^[^0-9!@#$%^&*()_+={}|\\\\;\"\n\r\t\[\]<>?/-][^0-9!@#$%^&*()_+={}|\\\\;\"\n\r\t\[\]<>?/]{1,30}$/;



// WEBPACK FOOTER //
// ./src/constants/customerInfo.js